module.exports = __webpack_public_path__ + "static/media/back_arrow_pink.0addf458.svg";